import { render, staticRenderFns } from "./ExpiredBonus.vue?vue&type=template&id=d12f73cc&scoped=true&"
import script from "./ExpiredBonus.vue?vue&type=script&lang=js&"
export * from "./ExpiredBonus.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredBonus.vue?vue&type=style&index=0&id=d12f73cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12f73cc",
  null
  
)

export default component.exports